import LearningSpaceCourseCertificate from './LearningSpaceCourseCertificate'

export default LearningSpaceCourseCertificate